<!-- CREATE NEW SITE MODAL -->
<div id="createSiteDialog" appDraggable dragTarget="#createSiteDialog" dragHandle="#createSiteDialogHeader" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModal2Label">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div id="createSiteDialogHeader" class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
				<h4 class="modal-title">NEW SITE</h4>
			</div>
			<div class="modal-body">
				<div class="form-group">
					<label>Name:</label>
					<br>
					<input [(ngModel)]="mLocationName" type="text" class="form-control">
					<label>Location Type:</label>
					<select [(ngModel)]="mLocationType" class="form-control">
						<ng-container *ngIf="locationTypes != null">
							<option *ngFor="let locationType of locationTypes" [ngValue]="locationType">
								{{locationType.name}}
							</option>
						</ng-container>
					</select>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">CLOSE</button>
				<button type="button" class="btn btn-primary" (click)="createSiteClicked()">CREATE SITE</button>
			</div>
		</div>
	</div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>